import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea306c16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "row my-2" }
const _hoisted_4 = { class: "col mb-1" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1))
const _hoisted_8 = { class: "mb-0 pr-1" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "30",
  width: "30"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-cadac" })
], -1))
const _hoisted_11 = { class: "mb-0 text-bold" }
const _hoisted_12 = { class: "row mb-2" }
const _hoisted_13 = { class: "col mb-1" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1))
const _hoisted_17 = { class: "mb-0 pr-1" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_19 = { class: "icon-available-tickets" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "#000",
  height: "22",
  width: "22"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-support-avatar" })
], -1))
const _hoisted_21 = { class: "row mb-2" }
const _hoisted_22 = { class: "col mb-1" }
const _hoisted_23 = { class: "d-flex flex-column" }
const _hoisted_24 = { class: "mb-1" }
const _hoisted_25 = { class: "mb-0 pr-1" }
const _hoisted_26 = { class: "p-inputgroup" }
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "30",
  width: "30"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-cadac" })
], -1))
const _hoisted_30 = { class: "mb-0 text-bold" }
const _hoisted_31 = { class: "mb-0 text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.vm.pageTitle)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.vm.pageTitle), 1))
      : _createCommentVNode("", true),
    (_ctx.vm.introText)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "lead",
          innerHTML: _ctx.vm.introText
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Panel, {
          id: "panel-supportSubscriptions",
          toggleable: false
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportOverview.panel.titleSupportSubscriptions")) + " ", 1),
                (_ctx.vm.supportSubscriptionsHelpText)
                  ? (_openBlock(), _createBlock(_component_PopoverIcon, {
                      key: 0,
                      class: "d-inline-flex",
                      content: _ctx.vm.supportSubscriptionsHelpText,
                      placement: "right"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("myCadac.supportOverview.panel.subtitleSupportSubscriptions")), 1)
            ]),
            (_ctx.vm.supportContractSupportAssets?.length)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-raised p-button-success p-button-arrow p-button-sm",
                  disabled: !_ctx.urlToCreateTicketForAsset,
                  label: _ctx.$t('myCadac.supportOverview.button.submitSupportRequest'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {
							_ctx.openUrl(_ctx.urlToCreateTicketForAsset);
							$event.target.disabled = true;
						})
                }, null, 8, ["disabled", "label"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_ctx.vm.supportContractSupportAssets?.length)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  selection: _ctx.selectedSupportContractAsset,
                  "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSupportContractAsset) = $event)),
                  "removable-sort": "",
                  "responsive-layout": "scroll",
                  "selection-mode": "single",
                  value: _ctx.vm.supportContractSupportAssets
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "title",
                      sortable: false
                    }, {
                      body: _withCtx((item) => [
                        _createElementVNode("div", _hoisted_9, [
                          (item.data.icon)
                            ? (_openBlock(), _createBlock(_component_Avatar, {
                                key: 0,
                                alt: "product-icon",
                                class: "mr-1 bg-transparent",
                                image: item.data.icon,
                                shape: "square"
                              }, null, 8, ["image"]))
                            : (_openBlock(), _createBlock(_component_Avatar, {
                                key: 1,
                                alt: "product-icon",
                                class: "mr-1 bg-transparent",
                                shape: "square"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              })),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(item.data.title), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["selection", "value"]))
              : _createCommentVNode("", true),
            (!_ctx.vm.supportContractSupportAssets?.length)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 1,
                  closable: false,
                  severity: "warn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportOverview.panel.noSupportSubscriptionsMessage")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Panel, {
          id: "panel-supportTickets",
          toggleable: false
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportOverview.panel.titleTickets")) + " ", 1),
                (_ctx.vm.supportTicketsHelpText)
                  ? (_openBlock(), _createBlock(_component_PopoverIcon, {
                      key: 0,
                      class: "d-inline-flex",
                      content: _ctx.vm.supportTicketsHelpText,
                      placement: "right"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("myCadac.supportOverview.panel.subtitleTickets")), 1)
            ]),
            _createVNode(_component_Button, {
              class: "p-button-raised p-button-success p-button-arrow p-button-sm",
              label: _ctx.$t('myCadac.supportOverview.button.submitSupportRequest'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => {
							_ctx.openUrl(_ctx.vm.supportTicketsCreatePageUrl);
							$event.target.disabled = true;
						})
            }, null, 8, ["label"])
          ]),
          default: _withCtx(() => [
            (_ctx.vm.availableAmountOfSupportTickets)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.vm.availableAmountOfSupportTickets), 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$tc(
								"myCadac.supportOverview.panel.availableTickets",
								_ctx.vm.availableAmountOfSupportTickets
							)), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.vm.availableAmountOfSupportTickets)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 1,
                  closable: false,
                  severity: "warn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportOverview.panel.noTicketsMessage")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.vm.supportTicketsBuyPageUrl)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  class: "p-button-raised p-button-primary",
                  label: _ctx.$t('myCadac.supportOverview.button.buyTickets'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {
						_ctx.openUrl(_ctx.vm.supportTicketsBuyPageUrl);
						$event.target.disabled = true;
					})
                }, null, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_Panel, {
          id: "panel-addSoftware",
          toggleable: false
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("myCadac.supportOverview.panel.titleAddSoftware")), 1),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("myCadac.supportOverview.panel.subtitleAddSoftware")), 1)
            ]),
            _createVNode(_component_Button, {
              class: "p-button-raised p-button-success p-button-arrow p-button-sm ml-auto",
              disabled: !_ctx.productsToAdd.length,
              label: _ctx.$t('myCadac.supportOverview.button.addProductsToCart'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addSupportProductToCart()))
            }, null, 8, ["disabled", "label"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.selectedProducts,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedProducts) = $event)),
                "force-selection": "",
                "min-length": 2,
                multiple: true,
                "option-label": "title",
                placeholder: _ctx.$t('myCadac.supportOverview.autocomplete.placeholder'),
                suggestions: _ctx.searchProductResults,
                onComplete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearchTrigger($event)))
              }, {
                option: _withCtx(({ option }) => [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (option.icon)
                        ? (_openBlock(), _createBlock(_component_Avatar, {
                            key: 0,
                            alt: "product-icon",
                            class: "mr-1 bg-transparent",
                            image: option.icon,
                            shape: "square"
                          }, null, 8, ["image"]))
                        : (_openBlock(), _createBlock(_component_Avatar, {
                            key: 1,
                            alt: "product-icon",
                            class: "mr-1 bg-transparent",
                            shape: "square"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 1
                          })),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(option.title), 1)
                    ]),
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("myCadac.supportOverview.autocomplete.yearPrice", {
											price: _ctx.formatCurrency(option.yearPrice),
										})), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "suggestions"]),
              _createVNode(_component_Button, {
                class: "p-button-primary",
                icon: "pi pi-search"
              })
            ]),
            (_ctx.searchProductNoResults)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  closable: false,
                  severity: "warn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportOverview.autocomplete.msgNoResults", { query: _ctx.searchQuery })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 2,
          vm: _ctx.productAddedVm
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}